// https://github.com/instructure/pdf-annotate.js/blob/master/src/UI/page.js#L200
// See http://www.html5rocks.com/en/tutorials/canvas/hidpi/
export function getOutputScale(canvas) {
  const devicePixelRatio = window.devicePixelRatio || 1
  const backingStoreRatio =
    canvas.webkitBackingStorePixelRatio ||
    canvas.mozBackingStorePixelRatio ||
    canvas.msBackingStorePixelRatio ||
    canvas.oBackingStorePixelRatio ||
    canvas.backingStorePixelRatio ||
    1
  return devicePixelRatio / backingStoreRatio
}

export function setDimensionsOnCanvas(canvas, viewportHeight, viewportWidth) {
  canvas.dataset.originalHeight = viewportHeight
  canvas.dataset.originalWidth = viewportWidth
  canvas.height = viewportHeight
  canvas.width = viewportWidth
}

export const areEqual = (prevProps, nextProps) => {
  const shouldUpdate =
    prevProps.page !== nextProps.page ||
    prevProps.viewportHeight !== nextProps.viewportHeight ||
    prevProps.viewportWidth !== nextProps.viewportWidth ||
    prevProps.customPageRotation !== nextProps.customPageRotation ||
    (prevProps.shouldBeRendered !== nextProps.shouldBeRendered &&
      prevProps.shouldBeRendered === false)
  return shouldUpdate === false
}
